import type { SettingGroupDefinition } from "../../settings-catalog/types";
import {
  ShippingFulfillmentPromiseFlatTeamSettingGroups as originalGroups,
  type ShippingFulfillmentPromiseFlatTeamSettingGroupId as OriginalGroupId,
} from "./groups";

export type ShippingFulfillmentPromiseFlatTeamSettingGroupId =
  | OriginalGroupId
  | "shipping_fulfillment_promise.promise_days";

const cutoffGroup = originalGroups[0];
const orderManagementTarget = {
  type: "settings",
  path: "order-management?section=fulfillment-promise",
} as const;

export const ShippingFulfillmentPromiseFlatTeamSettingGroups = [
  {
    ...cutoffGroup,
    id: "shipping_fulfillment_promise.promise_days",
    title: "Fulfillment promise",
    description: "Set the number of working days it takes to fulfill an order.",
    fullPageTarget: orderManagementTarget,
    synonyms: undefined,
  },
  {
    ...cutoffGroup,
    title: "Fulfillment schedule",
    fullPageTarget: orderManagementTarget,
  },
] as const satisfies readonly SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>[];

export const ShippingFulfillmentPromiseFlatTeamSettingGroupById =
  Object.fromEntries(
    ShippingFulfillmentPromiseFlatTeamSettingGroups.map((group) => [
      group.id,
      group,
    ]),
  ) as Record<
    ShippingFulfillmentPromiseFlatTeamSettingGroupId,
    SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>
  >;
